export default __webpack_public_path__ + "static/pulzion25Img-2747624ddba6fe2ebfe1d7c4458d949f.jpeg";